import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { ALBUM_COVER, IMAGES, LINKS } from "@/data";

const POSTS = [
  { img: IMAGES.concert, alt: "La band al completo sul palco" },
  { img: ALBUM_COVER, alt: "Linea Cremisi EP — fuori ora" },
  { img: IMAGES.group, alt: "La band al porto prima del live" },
  { img: IMAGES.drummer, alt: "Cristiano sulla batteria, live sul mare" },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

export default function InstagramSection() {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative border-t border-neutral-900"
    >
      <div className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-end">
          <div>
            <motion.p
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="font-mono-tac text-xs uppercase tracking-[0.35em] text-red-600"
            >
              08 — Social
            </motion.p>
            <motion.h2
              variants={reveal}
              custom={1}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="font-display mt-4 text-5xl uppercase leading-none text-neutral-100 sm:text-7xl"
            >
              @lineacremisi
            </motion.h2>
            <motion.p
              variants={reveal}
              custom={2}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="mt-4 max-w-md text-base text-neutral-400"
            >
              Backstage, date live e tutto il rumore che non entra in un disco.
              Seguici su Instagram.
            </motion.p>
          </div>
          <motion.a
            variants={reveal}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            data-testid="instagram-profile-button"
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#C8102E] px-7 py-4 font-mono-tac text-sm uppercase tracking-[0.2em] text-white transition-all duration-200 hover:scale-105 hover:bg-[#FF2A4B] hover:shadow-[0_0_35px_rgba(200,16,46,0.6)] active:scale-95"
          >
            <Instagram className="h-4 w-4" />
            Seguici su Instagram
          </motion.a>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 lg:grid-cols-4">
          {POSTS.map((post, i) => (
            <motion.a
              key={i}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              data-testid={`instagram-post-${i + 1}`}
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden border border-neutral-800"
            >
              <img
                src={post.img}
                alt={post.alt}
                className="h-full w-full object-cover grayscale-[0.4] transition-all duration-700 group-hover:scale-110 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Instagram className="h-7 w-7 text-red-500" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
